export const getActiveProjectMutationKey = () => [`planner_projects_flat`];

export const getFlatProjectsMutationKey = () => [`planner_projects_flat`];

export const getProjectAvatarMutationKey = () => [`planner_project_avatar`];

export const getProjectUsersMutationKey = () => [`planner_project_users`];

export const getProjectGeoFencesMutationKey = () => [`planner_project_geo_fences`];

export const getProjectGeoFenceMutationKey = () => [`planner_project_geo_fence`];
